<template>
    <div class="page-content">
        <div class="section main-section">
            <h1>About PlanIt</h1>
            <p>Know how the concept was born</p>

            <p class="paragraph">Founders of PlanIt initiated to create a platform where people can easily create their itineraries, keep track of them, and share them to other people. There is a big community of travellers and we want to help you plan how you can explore in your dream destinations.</p>

            <section>
                <h3>Vision</h3>
                <p>To become the leading itinerary maker in the Philippines and in Asia</p>
            </section>

            <section>
                <h3>Mission</h3>
                <p>Empower travellers to create valuable content for the community</p>
            </section>
        </div>

        <div class="section">
            <h2>Our Team</h2>
            <p>Meet the ideators, founders, and designers of PlanIt </p>

            <div class="founders-list">
                <div class="founder"
                    v-for="n in 4"
                    v-bind:key="n">
                    <img src="assets/images/founder1.png" alt="Founder's Image" />

                    <div class="founder__name">Name of Founder</div>
                    <div class="founder__title">Title or Position</div>

                    <p>Short bio of the founder. You can also include his hobbies and other initiatives outside of PlanIt.</p>

                    <div class="socials">
                        <a href="">
                            <i class="facebook-icon"></i>
                        </a>
                        <a href="">
                            <i class="twitter-icon"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'About',
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'about'
        },
    }
</script>

<style scoped lang="scss">
    .section {
        text-align: center;
    }

    .paragraph {
        margin: 40px auto 0;
        max-width: 675px;

        @media all and (min-width: $breakpoint + 1) {
            line-height: 30px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            line-height: 24px;
            font-size: 16px;
        }
    }


    section {
        margin-top: 50px;

        @media all and (max-width: $breakpoint) {
            margin-top: 25px;
        }
    }


    section h3 {
        margin: 0;
        letter-spacing: 2px;
        text-transform: uppercase;
        font-weight: $black;
        font-size: 20px;

        @media all and (max-width: $breakpoint) {
            font-size: 16px;
        }
    }


    .founders-list {
        margin: 0 auto;

        @media all and (min-width: $breakpoint + 1) {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            max-width: 620px;
        }

        @media all and (max-width: $breakpoint) {
            font-size: 16px;
        }
    }


    .founder {
        margin-top: 56px;
        width: max-content;
        text-align: center;

        @media all and (max-width: $breakpoint) {
            margin: 20px auto;
        }
    }


    .founder__name {
        font-weight: $heavy;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 30px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            font-size: 16px;
        }
    }


    .founder__title {
        text-transform: uppercase;
        font-weight: $medium;
        font-size: 12px;
        color: $accent-two;

        @media all and (max-width: $breakpoint) {
            font-size: 10px;
        }
    }


    .founder p {
        margin: 14px auto 0;
        max-width: 210px;

        @media all and (min-width: $breakpoint + 1) {
            line-height: 18px;
            font-size: 12px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 7px;
            line-height: 16px;
            font-size: 10px;
        }
    }


    .socials {
        display: flex;
        justify-content: center;
        margin-top: 22px;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .facebook-icon,
    .twitter-icon {
        background: no-repeat center;
        background-size: contain;
        display: inline-block;
        width: 36px;
        height: 36px;
    }

    .facebook-icon {
        background-image: url('/assets/images/icons/facebook_dark.svg');
    }

    .twitter-icon {
        background-image: url('/assets/images/icons/twitter_dark.svg');
        margin-left: 36px;
    }
</style>
